import { localeFallbacks } from '../../var/translations/configuration'
import { trans, setLocaleFallbacks } from '@symfony/ux-translator'
/*
 * This file is part of the Symfony UX Translator package.
 *
 * If folder "app/assets/translations" does not exist, or some translations are missing,
 * you must warmup your Symfony cache to refresh JavaScript translations.
 *
 * If you use TypeScript, you can rename this file to "translator.ts" to take advantage of types checking.
 */

setLocaleFallbacks(localeFallbacks)

const getLocale = () => {
  return document.documentElement.getAttribute('data-symfony-ux-translator-locale') ||
    document.documentElement.lang ||
    'en'
}

export { trans, getLocale }

export * from '../../var/translations'
